import type { KeyedMutator, SWRConfiguration } from 'swr';
import useSWR from 'swr';

import type { ErrorCustom } from '@/utils/client';
import { get } from '@/utils/client';

import type { ProfileType } from '@/components/pages/giveaway-picker/Types/types';

import { GIVEAWAY_PICKER_SIGNIN } from '@/routes/apiToolsEndpoints';

export type MutateSocialProfileType = KeyedMutator<ProfileType[]>;

const useSocialProfile = (options?: SWRConfiguration<ProfileType[], ErrorCustom>) => {
    const {
        data,
        mutate: mutateSocialProfile,
        error: socialProfileError,
        isLoading
    } = useSWR<ProfileType[], ErrorCustom>(
        GIVEAWAY_PICKER_SIGNIN,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: true,
            ...options
        }
    );

    return {
        userSocialProfileData: data,
        mutateSocialProfile,
        socialProfileError,
        isLoading
    };
};
export default useSocialProfile;
